// src/utils/time.ts
export function nowInTZ(timezone: string): Date {
  return new Date(new Date().toLocaleString("en-US", { timeZone: timezone }));
}

export function getHMInTZ(timezone: string): { hour: number; minute: number } {
  const d = nowInTZ(timezone);
  return { hour: d.getHours(), minute: d.getMinutes() };
}

export function dayProgressPercent(timezone: string): number {
  const { hour, minute } = getHMInTZ(timezone);
  const total = hour * 60 + minute;
  return Math.min(100, Math.max(0, (total / 1440) * 100));
}

export function isBetweenTZ(timezone: string, fromHour: number, toHour: number): boolean {
  const { hour } = getHMInTZ(timezone);
  return hour >= fromHour && hour < toHour;
}

export function isAfterTZ(timezone: string, hour: number, minute = 0): boolean {
  const { hour: h, minute: m } = getHMInTZ(timezone);
  return h > hour || (h === hour && m >= minute);
}
